module.exports = __webpack_public_path__ + "static/img/5c.39dd9a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5c.jpg
// module id = yV1X
// module chunks = 0